import { render, staticRenderFns } from "./PageParams.vue?vue&type=template&id=5f33cf59"
import script from "./PageParams.vue?vue&type=script&lang=js"
export * from "./PageParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f33cf59')) {
      api.createRecord('5f33cf59', component.options)
    } else {
      api.reload('5f33cf59', component.options)
    }
    module.hot.accept("./PageParams.vue?vue&type=template&id=5f33cf59", function () {
      api.rerender('5f33cf59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PageParams.vue"
export default component.exports